import React, { useState, useCallback } from 'react';
import Modal from 'react-modal';

const customStyles = {
  overlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.85)',
  },
  content: {
    top: '30%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    padding: '0',
  },
};

const DeleteDepartmentButton = ({ property_id, onClick }) => {
  const [modalIsOpen, setModalIsOpen] = useState(false);

  const openModal = useCallback(() => {
    setModalIsOpen(true);
  }, []);

  const closeModal = useCallback(() => {
    setModalIsOpen(false);
  }, []);

  const handleDelete = useCallback(() => {
    onClick(property_id);
    closeModal();
  }, [onClick, property_id]);

  return (
    <span>
      <Modal
        isOpen={modalIsOpen}
        onRequestClose={closeModal}
        style={customStyles}
        contentLabel="Delete Department"
        ariaHideApp={false}
      >
        <div className="card card-warning">
          <div className="card-header text-white">
            Delete Department
            <button className="btn btn-sm btn-danger float-end" onClick={closeModal}>
              x
            </button>
          </div>
          <div className="card-block bg-white text-center">
            <h3>Are You Sure you Want to Delete?</h3>
          </div>
          <div className="card-footer">
            <button className="btn btn-sm btn-danger float-start" onClick={closeModal}>
              Cancel
            </button>
            <button className="btn btn-sm btn-danger float-end" onClick={handleDelete}>
              <i className="fas fa-trash-alt" /> Delete Department
            </button>
          </div>
        </div>
      </Modal>
      <button className="btn btn-sm btn-danger float-end space-right-2" onClick={openModal}>
        Delete Department <i className="fas fa-trash-alt" />
      </button>
    </span>
  );
};

export default DeleteDepartmentButton;